import React from "react";
import NFTTransactionsView2 from "./View";

const GasTransactions = () => {
  return <NFTTransactionsView2 />;
};

export default GasTransactions;
